import { isMobile } from 'react-device-detect';
import DeviceDetector from 'device-detector-js';
import { shouldTrackUser } from '../common/Mixpanel';

// Load Segment's analytics.js script dynamically
export const segmentLoad = () => {
  if (!shouldTrackUser()) return;
  if (!window?.analytics) {
    const segmentId = process.env.REACT_APP_SEGMENT_ID;
    const script = document.createElement('script');
    script.src = `https://cdn.segment.com/analytics.js/v1/${segmentId}/analytics.min.js`;
    script.async = true;
    script.onload = () => {
      console.log('Segment analytics.js loaded');
      window?.analytics?.load(segmentId);
      window?.analytics?.page(); // Send a page view on load
    };
    document?.head?.appendChild(script);
  } else {
    window?.analytics?.page(); // Send a page view if already loaded
  }
};

export const getCurrentDeviceInfo = () => {
  const deviceDetector = new DeviceDetector();
  if (deviceDetector) {
    const userAgent = navigator.userAgent;
    // Parse the device information
    const device = deviceDetector.parse(userAgent);
    // console.log(device, 'event sent device');
    return {
      client_name: device?.client?.name || '',
      client_type: device?.client?.type || '',
      Device_Type: device?.device?.type || '',
      Device_Brand: device?.device?.brand || '',
      Device_Model: device?.device?.model || '',
      OS_name: device?.os?.name || '',
      OS_Version: device?.os?.version || '',
      OS_Platform: device?.os?.platform || '',
    };
  }
  return {};
};

export const callTrackEvent = async (event, data = {}, addCustOrgId) => {
  let guestData = localStorage.getItem('current_user');
  if (guestData && shouldTrackUser()) {
    guestData = JSON.parse(guestData);
    const url = window.location.href;
    const utm_source = url.split('utm_source=');
    let finalUtmUrl = '';
    if (utm_source?.length > 1) {
      finalUtmUrl = utm_source[1].split('&')[0];
    }
    const deviceData = getCurrentDeviceInfo();
    if (window.analytics) {
      const objToSend = {
        Guid: guestData?.id || '',
        Timestamp: new Date().toISOString(),
        Source: finalUtmUrl,
        // PageSource: url,
        URL: url,
        User_name: guestData?.user?.name,
        User_EmailId: guestData?.user?.email,
        Medium: isMobile ? 'Mobile' : 'Application',
        LoggedIn: guestData?.is_guest ? 'No' : 'Yes',
        ...deviceData,
        ...data,
      };
      if (addCustOrgId) {
        objToSend['Org_id'] = guestData?.organization;
        objToSend['Cust_id'] = guestData?.id;
      }
      window.analytics.track(event, objToSend);
      console.log(event, 'event sent to Segment', objToSend);
    }
  }
};
